import { defineComponent, h } from 'vue';
// import './VLabel.scss';

export const VLabels = defineComponent({
  name: 'VLabels',
  render() {
    return h('div', { class: 'v-labels' }, this.$slots.default?.());
  },
});
